module.exports = __webpack_public_path__ + "static/media/join-work-life-new.4d5cb6b9.svg";